"use client";

import { BlackOpacityContext } from "@/context/blackOpacityContext";
import { BookMenuContext } from "@/context/bookMenuContext";
import { MenuContext } from "@/context/menuContext";
import { PopupContext } from "@/context/popupContext";
import styles from "@/styles/modules/components/header/blackOpacity.module.scss";
import { useContext } from "react";

export default function BlackOpacity() {
  const { isBlackOpacityOpen } = useContext(BlackOpacityContext);
  const { closeMenu } = useContext(MenuContext);
  const { closeBookMenu } = useContext(BookMenuContext);
  const { closePopup } = useContext(PopupContext);

  const closeTabs = () => {
    closeMenu();
    closeBookMenu();
    closePopup();
  };

  return (
    <div
      className={`${styles.blackOpacity} ${
        isBlackOpacityOpen ? styles.active : ""
      }`}
      onClick={closeTabs}
    />
  );
}
